// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill'
import Vue from 'vue'
import router from './router'
import ElementUI from 'element-ui'

import 'quill/dist/quill.core.css' //富文本编辑器css

import 'quill/dist/quill.snow.css' //富文本编辑器css

import 'quill/dist/quill.bubble.css' //富文本编辑器css

import 'swiper/dist/css/swiper.min.css';
import 'element-ui/lib/theme-chalk/index.css'
import locale from 'element-ui/lib/locale/lang/zh-CN'

import './assets/sass/content.css'
//全局参数
/* import GeminiScrollbar from 'vue-gemini-scrollbar'
Vue.use(GeminiScrollbar) */

import global_ from './components/global'
Vue.prototype.GLOBAL = global_

import axios from 'axios';
Vue.prototype.$axios = axios;

import * as filters from './assets/js/filter.js'
Object.keys(filters).forEach(key => {
    Vue.filter(key, filters[key])
})
import * as typefilters from './assets/js/typefilter.js'
Object.keys(typefilters).forEach(key => {
    Vue.filter(key, typefilters[key])
})
import * as dictilters from './assets/js/dictfilter.js'
Object.keys(dictilters).forEach(key => {
    Vue.filter(key, dictilters[key])
})


Vue.config.productionTip = false

var VueQuillEditor = require('vue-quill-editor')
Vue.use(VueQuillEditor)
import utils from './utils/utils.js';
Vue.use(utils);
Vue.prototype.$utils = utils;

import App from './App'
import '@/permission' // 权限
import { default as api } from './utils/api'
// import {hasPermission} from "./utils/hasPermission"; // 朱杰



import store from './store'
Vue.use(ElementUI, { locale })
Vue.prototype.api = api


router.afterEach((to, from, next) => {
    window.scrollTo(0, 0);
});

/* eslint-disable no-new */
// Vue.prototype.getConfigJson = function() {
//     Vue.prototype.$axios.get('../static/region/region.json').then((result) => {
//         Vue.prototype.GLOBAL.region = result.data
new Vue({
        el: '#app',
        render: h => h(App),
        router,
        store,
        components: { App },
        template: '<App/>'
    })
    // }).catch((error) => {
    //     console.log(error)
    // })
    // }
    // Vue.prototype.getConfigJson()



// WEBPACK FOOTER //
// ./src/main.js